var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.181,
    height: 14.997,
    viewBox: "0 0 13.181 14.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bin",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4319",
    "data-name": "Path 4319",
    d: "M42.863,1.757h-2.2V1.318A1.32,1.32,0,0,0,39.348,0H35.833a1.32,1.32,0,0,0-1.318,1.318v.439h-2.2a1.318,1.318,0,0,0-.41,2.571l.784,9.46A1.326,1.326,0,0,0,34.005,15h7.17a1.326,1.326,0,0,0,1.314-1.209l.784-9.46a1.318,1.318,0,0,0-.41-2.571Zm-7.469-.439a.44.44,0,0,1,.439-.439h3.515a.44.44,0,0,1,.439.439v.439H35.394Zm6.22,12.4a.442.442,0,0,1-.438.4h-7.17a.442.442,0,0,1-.438-.4L32.8,4.394h9.59Zm1.249-10.2H32.318a.439.439,0,0,1,0-.879H42.863a.439.439,0,1,1,0,.879Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4320",
    "data-name": "Path 4320",
    d: "M152.316,187.5l-.439-7.088a.439.439,0,0,0-.877.054l.439,7.088a.439.439,0,1,0,.877-.054Zm1.758-7.5a.439.439,0,0,0-.439.439v7.088a.439.439,0,1,0,.879,0v-7.088A.439.439,0,0,0,154.074,180Zm2.663,0a.44.44,0,0,0-.466.411l-.439,7.088a.439.439,0,1,0,.877.054l.439-7.088A.439.439,0,0,0,156.738,180Z",
    transform: "translate(-116.484 -174.726)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.139820ecc7b9d28b30a1331f9334c412.svg";
export { ForwardRef as ReactComponent };